import React, { useState } from "react";
import { Layout, Button, ConfigProvider, Grid } from "antd";
import { useDarkMode } from "src/context/DarkModeContext";
import { Link } from "react-router-dom";
import { MenuOutlined } from "@ant-design/icons";
import MenuItems from "../menu/MenuItems";
import MobileMenu from "../menu/MobileDrawer";
import Profile from "../Profile";
import "./Header.css";

const { Header } = Layout;
const { useBreakpoint } = Grid;

interface AppHeaderProps {
    handleSignOut: () => Promise<void>;
}

const AppHeader: React.FC<AppHeaderProps> = ({ handleSignOut }) => {
    const { isDarkMode } = useDarkMode();
    const [menuVisible, setMenuVisible] = useState(false);
    const screens = useBreakpoint();
    const isMobile = !screens.md; 

    const showMenu = () => setMenuVisible(true);

    return (
        <ConfigProvider>
            <Header className={`app-header ${isDarkMode ? 'dark' : 'light'}`}>
                {/* App Title */}
                <h1 className="app-title">
                    <Link to="/" className="app-title-link">
                        Spanish Checkpoint
                    </Link>
                </h1>


                {/* Desktop Menu (Visible on larger screens) */}
                {!isMobile && (
                    <div className="desktop-menu">
                        <MenuItems isDarkMode={isDarkMode} />
                        <Profile handleSignOut={handleSignOut} />
                    </div>
                )}

                {/* Mobile Menu - Visible on Small Screens */}
                {isMobile && (
                    <>
                        <Button
                            type="link"
                            icon={<MenuOutlined />}
                            onClick={showMenu}
                            size="large"
                            className="hamburger-menu"
                            style={{
                                color: "#D3D3D3", // Whitish gray color
                                display: "flex",
                                alignItems: "center", // Align button in center vertically
                            }}
                        />
                        <MobileMenu
                            menuVisible={menuVisible}
                            setMenuVisible={setMenuVisible}
                            handleSignOut={handleSignOut}
                        />

                    </>
                )}
            </Header>
        </ConfigProvider>
    );
};

export default AppHeader;
